<template>
  <div v-if="!$store.getters['user/getUserFields'].is_admin">
    Вы не администратор, авторизируйтесь как администратор!
  </div>

  <div v-else style="width: 100%; padding: 10px">
    <h3>Количество активных обзвонов: {{ list.length }}</h3>

    <button
      :disabled="stopAllDisabled"
      @click="stopAll"
      style="background: #f31510; padding: 8px; margin: 5px; border-radius: 5px; color: white"
    >
      Остановить все обзвоны
    </button>

    <button
      v-if="hasStoppedCalls"
      :disabled="resumeAllDisabled"
      @click="resumeAll"
      style="background: orange; padding: 8px; margin: 5px; border-radius: 5px; color: white"
    >
      Возобновить остановленные
    </button>

    <button
      v-if="list.length"
      @click="showModal = true"
      style="background: #1976d2; padding: 8px; margin: 5px; border-radius: 5px; color: white"
    >
      Статистика по пользователям
    </button>

    <div style="width: 100%; margin-top: 20px">
      <h3>Список активных обзвонов</h3>

      <div style="display: flex; width: 100%; flex-direction: row">
        <div style="width: 420px; border: 1px solid silver"><b>Идентификатор обзвона</b></div>
        <div style="width: 500px; border: 1px solid silver"><b>Название обзвона</b></div>
        <div
          style="width: 200px; border: 1px solid silver; cursor: pointer"
          @click="toggleSort"
        >
          <b>
            Пользователь
            <span v-if="sortAsc">▲</span><span v-else>▼</span>
          </b>
        </div>
        <div style="width: 180px; border: 1px solid silver"></div>
        <div style="width: 180px; border: 1px solid silver"></div>
      </div>

      <div style="width: 100%;">
        <div
          v-for="item in sortedList"
          :key="item.key"
          style="width: 100%; display: flex; flex-direction: row; height: 50px"
        >
          <div
            style="width: 420px; border-left: 1px solid silver; border-right: 1px solid silver; border-bottom: 1px solid silver; text-align: left; padding: 10px"
          >
            {{ item.key }}
          </div>
          <div
            style="width: 500px; border-left: 1px solid silver; border-right: 1px solid silver; border-bottom: 1px solid silver; text-align: left; padding: 10px"
          >
            {{ item.name }}
          </div>
          <div
            style="width: 200px; border-left: 1px solid silver; border-right: 1px solid silver; border-bottom: 1px solid silver; text-align: left; padding: 10px"
          >
            {{ item.user }}
          </div>
          <div
            style="width: 180px; border-left: 1px solid silver; border-right: 1px solid silver; border-bottom: 1px solid silver"
          >
            <button
              style="background: #f31510; padding: 8px; margin: 5px; opacity: 90%; border-radius: 5px; color: white"
              class="hvr"
              @click="stop(item.key, item.user)"
            >
              Остановить
            </button>
          </div>
          <div
            style="width: 180px; border-left: 1px solid silver; border-right: 1px solid silver; border-bottom: 1px solid silver"
          >
            <button
              style="background: orange; padding: 8px; margin: 5px; opacity: 90%; border-radius: 5px; color: white"
              class="hvr"
              @click="success(item.key, item.user)"
            >
              Завершить
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modalOverlay" @click.self="showModal = false">
      <div class="modalContent">
        <h3 style="margin-top: 0">Обзвоны по пользователям</h3>

        <div v-for="(cnt, user) in userStats" :key="user" style="margin: 4px 0">
          <b>{{ user }}</b> — {{ cnt }}
        </div>

        <button
          @click="showModal = false"
          style="background: #1976d2; color: #fff; padding: 6px 12px; border-radius: 4px; margin-top: 12px"
        >
          Закрыть
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      hasStoppedCalls: false,
      stopAllDisabled: false,
      resumeAllDisabled: false,
      sortAsc: true,
      showModal: false
    };
  },
  computed: {
    sortedList() {
      return [...this.list].sort((a, b) =>
        this.sortAsc ? a.user.localeCompare(b.user) : b.user.localeCompare(a.user)
      );
    },
    userStats() {
      return this.list.reduce((acc, { user }) => {
        acc[user] = (acc[user] || 0) + 1;
        return acc;
      }, {});
    }
  },
  methods: {
    // Получить список всех активных обзвонов
    getAll() {
      this.$http.post('/list_calls/all', {}, (result) => {
        this.list = result;
      });
    },
    // Проверить, есть ли остановленные обзвоны
    checkStoppedCalls() {
      this.$http.post('/list_calls/checkStopped', {}, (resp) => {
        this.hasStoppedCalls = resp && resp.hasStopped;
      });
    },
    // Остановить конкретный обзвон
    stop(call_id, user) {
      this.$http.post('/list_calls/stop', { call_id, user }, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    // Завершить обзвон
    success(call_id, user) {
      this.$http.post('/list_calls/success', { call_id, user }, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    // Остановить все обзвоны
    stopAll() {
      this.stopAllDisabled = true;
      setTimeout(() => {
        this.stopAllDisabled = false;
      }, 15000);

      this.$http.post('/list_calls/stopAll', {}, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    // Возобновить ранее остановленные обзвоны
    resumeAll() {
      this.resumeAllDisabled = true;
      setTimeout(() => {
        this.resumeAllDisabled = false;
      }, 15000);

      this.$http.post('/list_calls/resumeAll', {}, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    toggleSort() {
      this.sortAsc = !this.sortAsc;
    }
  },
  mounted() {
    this.getAll();
    this.checkStoppedCalls();
  }
};
</script>

<style>
.hvr:hover {
  background: #bc4747 !important;
  color: black !important;
}

.modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modalContent {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px;
  max-width: 320px;
  width: 90%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}
</style>
